import { Button, toast, Tooltip } from "@validereinc/common-components";
import { copyTextToClipboard } from "@validereinc/utilities";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

export type ConversationMessageCopyButtonProps = {
  content: string;
  isUserMessage?: boolean;
};

/**
 * Icon button shown below a conversation message. Copies raw message content to
 * the clipboard and shows a success toast.
 */
export const ConversationMessageCopyButton = ({
  content,
  isUserMessage = false,
}: ConversationMessageCopyButtonProps) => {
  return (
    <Tooltip
      content="Copy message"
      position={["bottom"]}
      contentClassName={cx("conversation-feed__copy-button-tooltip", {
        "conversation-feed__copy-button-tooltip--user": isUserMessage,
      })}
    >
      <Button
        variant="outline"
        size="xx-small"
        icon="copy-simple"
        className={cx("conversation-feed__copy-button")}
        aria-label="Copy message to clipboard"
        onClick={() => {
          copyTextToClipboard(content)
            .then(() =>
              toast.push({
                intent: "success",
                description: "Successfully copied message to your clipboard.",
              })
            )
            .catch(() =>
              toast.push({
                intent: "error",
                description: "Failed to copy message to your clipboard.",
              })
            );
        }}
      />
    </Tooltip>
  );
};
